<button type="button" class="notification-link" (click)="$event.stopPropagation(); onLinkClick()">{{linkText}}</button>
